import { Alert, Button, DialogActions, DialogContent } from "@mui/material";
import React, { Fragment } from "react";
import useAppGlobal from "src/context/useAppGlobal";

export default function ConfirmComp({ name, onConfirm, custom }) {
  const { closeDialog } = useAppGlobal();
  return (
    <Fragment>
      <DialogContent sx={{ textAlign: "center" }}>
        <Alert severity={custom?.action ? "info" : "error"}>{custom?.label ? custom.label : "Bạn có chắc muốn xoá không?"}</Alert>
      </DialogContent>
      <DialogActions sx={{ p: "0px 12px 24px" }}>
        <Button
          sx={{ flex: 1 }}
          variant="outlined"
          onClick={closeDialog}
        >
          Hủy
        </Button>
        <Button
          sx={{ width: "68%" }}
          variant="contained"
          onClick={onConfirm}
        >
          Xác nhận
        </Button>
      </DialogActions>
    </Fragment>
  );
}
